import { Component, ElementRef, HostBinding, OnInit } from "@angular/core";

@Component({
	selector: "app-skeleton",
	template: ``,
	styleUrls: ["./skeleton.component.scss"],
	standalone: false
})
export class SkeletonComponent implements OnInit {
	width = "";
	minWidth = "";
	height = "";
	className = "";
	@HostBinding("class.shimmer") enableAnimation = true;
	@HostBinding("class.rounded-circle") circle = false;

	constructor(private host: ElementRef<HTMLElement>) {}

	ngOnInit() {
		const host = this.host.nativeElement;

		if (this.className) {
			const classList = this.className.split(" ");
			host.classList.add(...classList);
		}

		host.style.setProperty("--app-skeleton-width", this.width);
		host.style.setProperty("--app-skeleton-min-width", this.minWidth);
		host.style.setProperty("--app-skeleton-height", this.height);
	}
}
